<template>
  <div>
    <v-card
      
      outlined
      style="max-height: 30vh;overflow-y: scroll;"
    >
      <v-card-subtitle>他社区間代行起票 収運加入者</v-card-subtitle>
      <template
        v-for="transport in tenant.proxy_entry_subscribers_attributes"
      >
        <v-card-text
          v-if="!transport._destroy"
          :key="transport.key"
        >
          <v-row
            dense
          >
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                :rules="{max: 20}"
                :vid="`name-${transport.key}`"
                name="他社法人名"
              >
                <v-text-field
                  v-model="transport.name"
                  :error-messages="errors"
                  label="他社法人名"
                  persistent-placeholder
                  required
                >
                  <template v-slot:label>
                    <span>他社法人名</span>
                    <span class="ml-1">
                      ({{ transport.name?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                :rules="{required: (transport.subscriber_number), alpha_num_only: true, length: 7, subscriberNumberInitialsCheck: {mode: 'admin_transport', contract_type: contractUnitType}}"
                :vid="`subscriber_number-${transport.key}`"
                class="requiredMark"
                name="加入者番号"
              >
                <v-text-field
                  v-model="transport.subscriber_number"
                  :error-messages="errors"
                  label="加入者番号"
                  persistent-placeholder
                  required
                >
                  <template v-slot:label>
                    <span>加入者番号</span>
                    <span class="ml-1">
                      ({{ transport.subscriber_number?.length || 0 }} / 7)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                :rules="{required: (transport.confirmation_number), numeric: true, length: 6}"
                :vid="`confirmation_number-${transport.key}`"
                class="requiredMark"
                name="公開確認番号"
              >
                <v-text-field
                  v-model="transport.confirmation_number"
                  :error-messages="errors"
                  label="公開確認番号"
                  persistent-placeholder
                  required
                > 
                  <template v-slot:label>
                    <span>公開確認番号</span>
                    <span class="ml-1">
                      ({{ transport.confirmation_number?.length || 0 }} / 6)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
            
            <v-col
              cols="12"
              md="2"
              class="text-right"
            >
              <v-btn
                :disabled="disableRemoveButton"
                class="error"
                small
                @click="removeButtonClickEvent(transport)"
              >
                削除
              </v-btn>
            </v-col>
          </v-row>
          <v-divider class="mt-2" />
        </v-card-text>
      </template>
    </v-card>
    <br />
    <v-row dense>
      <v-col cols="12" class="text-right">
        <v-btn
          class="primary"
          small
          @click="addButtonClickEvent"
        >
          追加
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'ProxyEntrySubscriberForm',
  components: {},
  mixins: [],
  props: {
    tenant: {
      type: Object,
      default: () => null,
    },
    contractUnitType: {
      type: String,
      default: "trial_contract"
    },
  },
  computed: {
    disableRemoveButton () {
      return false
    }
  },
  watch: {},
  created() {
  },
  methods: {
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$emit('addButtonCallback')
    },
    /**
     * 削除ボタン クリックイベント
     * @param item
     */
    removeButtonClickEvent (item) {
      this.$emit('removeButtonCallback', item)
    },

  }
}
</script>
